(() => {
  if (window.MulettaSizeConfidenceTabsReady) {
    return;
  }

  window.MulettaSizeConfidenceTabsReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-size-confidence-tabs] button[role="tab"]');

    if (!button) {
      return;
    }

    const tabs = button.closest('[data-size-confidence-tabs]');
    const buttons = Array.from(tabs.querySelectorAll('button[role="tab"]'));
    const selectedIndex = buttons.indexOf(button);

    if (selectedIndex < 0) {
      return;
    }

    tabs.selectedIndex = selectedIndex;

    const tabScroller = tabs.shadowRoot?.querySelector('[part="tab-list-scrollable"]');

    if (
      window.matchMedia('(max-width: 899px)').matches &&
      tabScroller &&
      tabScroller.scrollWidth > tabScroller.clientWidth
    ) {
      button.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  });
})();
